import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_AUTO_ACTIVATION: createAsyncMutation('GET_AUTO_ACTIVATION'),
    GET_ALTERNATE_ACTIVATION: createAsyncMutation('GET_ALTERNATE_ACTIVATION'),
    GET_ACTIVATION_ERROR_INSTRUCTIONS: createAsyncMutation('GET_ACTIVATION_ERROR_INSTRUCTIONS'),
}

const autoactivation = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getActivationCode(store, payload) {
            let url = api.autoactivation + 'GetActivationCode'
            if (payload) {
                url += '?installId=' + String(payload?.InstallID ?? '')
                url += '&productLineId=' + String(payload?.ProductLineID ?? '')
                url += '&productId=' + String(String(payload?.ProductID ?? ''))
                url += '&edition=' + String(payload?.Edition ?? '')
                url += '&version=' + String(payload?.Version ?? '')
                url += '&oemId=' + String(payload?.OEMID ?? '')
                url += '&year=' + String(payload?.Year ?? '')
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_AUTO_ACTIVATION })
        },

        getAlternateActivation(store, payload) {
            let url = api.autoactivation + 'GetAlternateActivation'
            if (payload) {
                url += '?installId=' + String(payload?.InstallID ?? '')
                url += '&productLineId=' + String(payload?.ProductLineID ?? '')
                url += '&productId=' + String(String(payload?.ProductID ?? ''))
                url += '&edition=' + String(payload?.Edition ?? '')
                url += '&version=' + String(payload?.Version ?? '')
                url += '&oemId=' + String(payload?.OEMID ?? '')
                url += '&year=' + String(payload?.Year ?? '')
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_ALTERNATE_ACTIVATION })
        },

        getActivationErrorInstructions(store, payload) {
            let url = api.autoactivation + 'GetActivationErrorInstructions'
            if (payload) {
                url += '?activationException=' + String(payload ?? '')
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_ACTIVATION_ERROR_INSTRUCTIONS })
        }

    },
    getters: {},
    types: types
}

export default autoactivation
